export class Discovery {
  private discoveryForm: HTMLFormElement | null

  constructor() {
    this.discoveryForm = document.querySelector<HTMLFormElement>('#js-discovery')

    if (!this.discoveryForm) return

    this.setLength()
    this.setMode()
  }

  setLength(): void {
    if (!this.discoveryForm) return

    const input = this.discoveryForm.querySelector('#js-length') as HTMLInputElement
    const text = this.discoveryForm.querySelector('#js-length-text')
    const rangeInput = this.discoveryForm.querySelector('input[type="range"]') as HTMLInputElement

    if (!rangeInput || !input || !text) return

    const updateLength = (): void => {
      const value = parseInt(rangeInput.value, 10)
      const min = parseInt(rangeInput.min || '0', 10)
      const max = parseInt(rangeInput.max || '100', 10)

      if (Number.isNaN(value)) return

      const progress = max > min ? ((value - min) / (max - min)) * 100 : 0

      input.value = String(value)
      text.textContent = value === 1 ? '1 minute' : `${value} minutes`
      rangeInput.style.setProperty('--range-progress', `${progress}%`)
    }

    rangeInput.addEventListener('input', updateLength)
    this.discoveryForm.addEventListener('submit', updateLength)
    updateLength()
  }

  setMode(): void {
    if (!this.discoveryForm) return

    const modeInput = this.discoveryForm.querySelector('#js-mode') as HTMLInputElement
    const modeButtons = this.discoveryForm.querySelectorAll<HTMLButtonElement>('[data-discovery-mode]')

    if (!modeInput) return

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        modeInput.value = button.dataset.discoveryMode || '1'
      })
    })

    this.discoveryForm.addEventListener('submit', (event) => {
      const submitter = event instanceof SubmitEvent && event.submitter instanceof HTMLButtonElement
        ? event.submitter
        : null

      modeInput.value = submitter?.dataset.discoveryMode || '1'
    })
  }
}
